import styled from "styled-components";


export const FooterContainer = styled.div`
    background: #0B0E21;
    height: 15em;
    width: 100%;
`